import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_RECEIVER = gql `
  mutation UpdateWarehouseReleaseReceiver($warehouseReleaseNodeId: ID!, $receiver: String) {
    updateWarehouseReleaseReceiver(
      warehouseReleaseNodeId: $warehouseReleaseNodeId
      receiver: $receiver
    ) {
      warehouseRelease {
        id
        receiver
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_RECEIVER;
